import React from 'react';
import { Link } from 'react-router-dom';

const SessionExpired: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '40px',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)'
      }}>
        <div style={{
          fontSize: '4rem',
          marginBottom: '20px'
        }}>
          ⏰
        </div>

        <h1 style={{
          color: '#333',
          fontSize: '2rem',
          fontWeight: '600',
          marginBottom: '16px'
        }}>Session Expired</h1>

        <p style={{
          color: '#666',
          fontSize: '1.1rem',
          lineHeight: '1.6',
          marginBottom: '30px'
        }}>
          Your Reality Coach session has expired. To continue, please return to the legacy system and get a new magic link.
        </p>

        <div style={{
          display: 'flex',
          gap: '16px',
          justifyContent: 'center',
          marginBottom: '40px',
          flexWrap: 'wrap'
        }}>
          <a
            href="http://localhost:8001"
            style={{
              display: 'inline-block',
              padding: '12px 24px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '500',
              fontSize: '1rem',
              transition: 'all 0.3s ease',
              border: 'none',
              cursor: 'pointer',
              minWidth: '160px',
              background: '#667eea',
              color: 'white'
            }}
          >
            Return to Legacy System
          </a>

          <Link
            to="/login"
            style={{
              display: 'inline-block',
              padding: '12px 24px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '500',
              fontSize: '1rem',
              transition: 'all 0.3s ease',
              minWidth: '160px',
              background: '#f8f9fa',
              color: '#666',
              border: '2px solid #e9ecef'
            }}
          >
            Go to Login
          </Link>
        </div>

        <div style={{
          textAlign: 'left',
          background: '#f8f9fa',
          padding: '20px',
          borderRadius: '8px',
          borderLeft: '4px solid #667eea'
        }}>
          <h3 style={{
            color: '#333',
            fontSize: '1.2rem',
            marginBottom: '8px',
            fontWeight: '600'
          }}>Why did this happen?</h3>
          <p style={{
            color: '#666',
            fontSize: '0.95rem',
            lineHeight: '1.5',
            margin: '0'
          }}>
            Magic link sessions are designed to be secure and time-limited.
            When your session expires, you need to authenticate again through the legacy system.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SessionExpired;
